import { ChangeEventHandler, FocusEventHandler, forwardRef } from "react";

import { classNames } from "@utils/class-names";

interface Props {
  name: string;
  placeholder: string;
  rows?: number;
  value?: string;
  setValue?(value: string): void;
  label?: string;
  showLabel?: boolean;
  required?: boolean;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
  disabled?: boolean;
  format?(value: string): string;
}

const TextAreaInput = forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      name,
      placeholder,
      rows = 5,
      label,
      showLabel,
      required,
      value,
      setValue,
      onChange,
      onBlur,
      disabled,
      format,
    },
    ref
  ) => (
    <label htmlFor={name} className="block">
      <span className={classNames(showLabel ? "mb-3" : "sr-only")}>
        {showLabel ? label : placeholder}
        {required ? "*" : ""}
      </span>
      <textarea
        {...{
          id: name,
          name,
          placeholder,
          value: !ref ? value : undefined,
          onChange: (event) => {
            if (format) {
              event.target.value = format(event.target.value);
            }
            if (onChange) {
              onChange(event);
            }
            if (setValue) {
              setValue(event.target.value);
            }
          },
          onBlur,
          ref,
          disabled,
          rows,
        }}
        className="block w-full focus:outline-none focus:ring-2 focus:ring-gray-200 focus:ring-opacity-80 focus:border-black rounded-l"
      />
    </label>
  )
);

TextAreaInput.displayName = "TextAreaInput";

export default TextAreaInput;
